module.exports = __webpack_public_path__ + "img/book.3e16ae78.svg";